import { useState } from "react";

export default function InputRange({
  value,
  setValue, // start value in percent
}) {
  // Slider itself goes 0 → 100, but we *display* 100 → 0 like your image

  const activeColor = "#2878A3"; // your blue
  const inactiveColor = "rgba(148, 163, 184, 0.4)"; // your border-light/40

  const background = `linear-gradient(
    to left,
    ${activeColor} 0%,
    ${activeColor} ${value}%,
    ${inactiveColor} ${value}%,
    ${inactiveColor} 100%
  )`;

  return (
    <div className="w-full pt-0.5 flex flex-col items-center gap-0.5">
      {/* top row: 100  ---- slider ----  0 */}
      <div className="w-full flex items-center gap-1 sm:gap-2.5">
        <span className="text-xs sm:text-sm text-zi-text-light/50 dark:text-zi-text-dark/50">
          0
        </span>

        <input
          type="range"
          min="0"
          max="100"
          value={value}
          onChange={(e) => setValue(Number(e.target.value))}
          style={{ background }}
          className="
            w-full outline-none cursor-pointer appearance-none rounded-full
            accent-zi-blue-light
            [&::-webkit-slider-runnable-track]:h-1
            [&::-webkit-slider-runnable-track]:rounded-full
            [&::-webkit-slider-runnable-track]:bg-transparent
            dark:[&::-webkit-slider-runnable-track]:bg-transparent
            [&::-webkit-slider-runnable-track]:border-none
            [&::-webkit-slider-runnable-track]:appearance-none
            [&::-webkit-slider-thumb]:appearance-none
            [&::-webkit-slider-thumb]:size-2.5
            [&::-webkit-slider-thumb]:rounded-full
            [&::-webkit-slider-thumb]:bg-zi-blue-light
            [&::-webkit-slider-thumb]:mt-[-3px]
          "
        />
        <span className="text-xs sm:text-sm text-zi-text-light/50 dark:text-zi-text-dark/50">
          100
        </span>
      </div>

      {/* bottom centered value */}
      <div className="text-sm font-medium text-zi-text-light dark:text-zi-text-dark">
        {value.toFixed(2)}%
      </div>
    </div>
  );
}
